const MESSAGE_RULES: Array<[RegExp, string]> = [
  [/user id (doesn.?t exist|not found)|user not found/i, 'Utilizador não encontrado.'],
  [/invalid (id for a )?user|null id for a user/i, 'Não foi possível identificar o utilizador.'],
  [/email is already registered/i, 'Este email já se encontra registado.'],
  [/invalid email/i, 'Introduza um endereço de email válido.'],
  [/invalid password|password not valid/i, 'A palavra-passe não cumpre os requisitos de segurança.'],
  [/password not updated/i, 'Não foi possível alterar a palavra-passe.'],
  [/new password can.?t be the same/i, 'A nova palavra-passe tem de ser diferente da atual.'],
  [/invalid token|token.*(expired|invalid)|expired.*token/i, 'Este link já não é válido. Peça um novo link e tente novamente.'],
  [/form element id doesn.?t exist/i, 'Este campo já não existe no formulário.'],
  [/form id doesn.?t exist|form not found/i, 'Formulário não encontrado.'],
  [/form[_ ]unavailable|no permissions to view this form/i, 'Este formulário não está disponível.'],
  [/no stock for this form|over.stock/i, 'Já não existe disponibilidade para concluir este pedido.'],
  [/company id not found|company not found/i, 'Empresa não encontrada.'],
  [/api key was not found/i, 'Não foi encontrada uma chave API válida para esta operação.'],
  [/reply was not found/i, 'Resposta não encontrada.'],
  [/reference was not found/i, 'Referência de pagamento não encontrada.'],
  [/invalid client_id or client_secret/i, 'Não foi possível validar as credenciais Eupago. Confirme os dados e tente novamente.'],
  [/user has no access|no permissions|access denied|forbidden/i, 'Não tem permissão para realizar esta operação.'],
  [/there was an error processing your payment/i, 'Não foi possível processar o pagamento. Tente novamente.'],
  [/invalid price|price value|invalid cost/i, 'O valor indicado não é válido.'],
  [/bad request|error with your request/i, 'Não foi possível concluir o pedido. Confirme os dados introduzidos.'],
  [/failed to fetch|network error|load failed/i, 'Não foi possível ligar ao serviço. Verifique a ligação e tente novamente.'],
];

function extractMessage(value: unknown): string {
  if (value instanceof Error) return value.message;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '';
    try {
      return extractMessage(JSON.parse(trimmed));
    } catch {
      return trimmed;
    }
  }
  if (value && typeof value === 'object') {
    const candidate = value as Record<string, unknown>;
    return extractMessage(candidate.message ?? candidate.error ?? candidate.detail ?? candidate.title);
  }
  return '';
}

export function userFriendlyError(
  value: unknown,
  fallback = 'Não foi possível concluir a operação. Tente novamente.',
): string {
  const message = extractMessage(value);
  if (!message) return fallback;

  const rule = MESSAGE_RULES.find(([pattern]) => pattern.test(message));
  if (rule) return rule[1];

  // Never expose stack traces, implementation details or raw HTTP responses.
  if (/\b(exception|java\.|org\.|sql|stack trace|http \d{3}|userid|formid|companyid)\b/i.test(message)
      || /\b(the|invalid|not|cannot|failed|error|must|was|already|could|doesn.?t)\b/i.test(message)) {
    return fallback;
  }

  return message;
}
